var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b",
    staticStyle: {
      "box-shadow": "none"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "card-body"
  }, [_c('b-tabs', {
    staticClass: "hide-tabs",
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "placa",
      "label-for": "placa",
      "label": "Placa"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['AAA-#X##'],
      expression: "['AAA-#X##']"
    }],
    attrs: {
      "maxlength": "100",
      "autofocus": "",
      "state": _vm.validateState('placa')
    },
    model: {
      value: _vm.form.placa,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "placa", $$v);
      },
      expression: "form.placa"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "uf",
      "label-for": "uf",
      "label": "UF"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "2",
      "autofocus": "",
      "state": _vm.validateState('uf')
    },
    model: {
      value: _vm.form.uf,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "uf", $$v);
      },
      expression: "form.uf"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "renavam",
      "label-for": "renavam",
      "label": "Renavam"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "100",
      "autofocus": "",
      "state": _vm.validateState('renavam')
    },
    model: {
      value: _vm.form.renavam,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "renavam", $$v);
      },
      expression: "form.renavam"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "descricao",
      "label-for": "descricao",
      "label": "Descrição"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "100",
      "autofocus": "",
      "state": _vm.validateState('descricao')
    },
    model: {
      value: _vm.form.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "descricao", $$v);
      },
      expression: "form.descricao"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "tipo_rodado",
      "label": "Tipo Rodado",
      "label-for": "tipo_rodado"
    }
  }, [_c('VueSelect', {
    class: {
      hasErrors: _vm.rodadosError
    },
    attrs: {
      "placeholder": "Selecione o tipo rodado",
      "label": "tipo_rodado",
      "filterable": false,
      "searchable": false,
      "options": _vm.tiposRodados,
      "state": _vm.validateState('tipo_rodado')
    },
    on: {
      "input": function input() {
        return _vm.rodadosError = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.tipo_rodado,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tipo_rodado", $$v);
      },
      expression: "form.tipo_rodado"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "tipo_caroceria",
      "label": "Tipo Caroceria",
      "label-for": "tipo_caroceria"
    }
  }, [_c('VueSelect', {
    class: {
      hasErrors: _vm.caroceriaError
    },
    attrs: {
      "placeholder": "Selecione o tipo de caroceria",
      "label": "tipo_caroceria",
      "filterable": false,
      "searchable": false,
      "options": _vm.tiposCaroceria,
      "state": _vm.validateState('tipo_caroceria')
    },
    on: {
      "input": function input() {
        return _vm.caroceriaError = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.tipo_caroceria,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tipo_caroceria", $$v);
      },
      expression: "form.tipo_caroceria"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "tara",
      "label-for": "tara",
      "label": "Tara"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "state": _vm.validateState('tara')
    },
    model: {
      value: _vm.form.tara,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tara", $$v);
      },
      expression: "form.tara"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "tara_kg",
      "label-for": "tara_kg",
      "label": "Tara Kg"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "state": _vm.validateState('tara_kg')
    },
    model: {
      value: _vm.form.tara_kg,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tara_kg", $$v);
      },
      expression: "form.tara_kg"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "capacidade_kg",
      "label-for": "capacidade_kg",
      "label": "Capacidade Kg"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "state": _vm.validateState('capacidade_kg')
    },
    model: {
      value: _vm.form.capacidade_kg,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "capacidade_kg", $$v);
      },
      expression: "form.capacidade_kg"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "capacidade_m3",
      "label-for": "capacidade_m3",
      "label": "Capacidade m3"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "state": _vm.validateState('capacidade_m3')
    },
    model: {
      value: _vm.form.capacidade_m3,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "capacidade_m3", $$v);
      },
      expression: "form.capacidade_m3"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "submit_novo_veiculo",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'veiculos'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-header border-0 py-5"
  }, [_c('h3', {
    staticClass: "card-title align-items-start flex-column"
  }, [_c('span', {
    staticClass: "card-label font-weight-bolder text-dark"
  }, [_vm._v(" Novo Veículo ")])])]);
}];
export { render, staticRenderFns };